module.exports = [
  {
    id: 'scenario_unknown',
    name: 'Сценарий использования неизвестен или не указан'
  },
  {
    id: 'manual_estimation',
    name: 'Запрос оценки данных пациента врачом в ручном режиме'
  },
  {
    id: 'analysis_refer',
    name: 'Автоматический анализ данных пациента при обращении пациента в МО'
  },
  {
    id: 'analysis_closed_case',
    name: 'Автоматический анализ данных пациента при завершении обследования/лечения в МО (закрытие случая, ИБ и т.д.)'
  },
  {
    id: 'analysis_treatment',
    name: 'Автоматический анализ данных во время нахождения пациента в медицинской организации'
  },
  {
    id: 'group_estimation',
    name: 'Автоматическая групповая оценка пациентов'
  },
  {
    id: 'retrospective_analysis',
    name: 'Ретроспективный анализ данных'
  },
  {
    id: 'automatic_analysis_pre_recorded_patients',
    name: 'Автоматический анализ предварительно записанных в МО пациентов'
  },
  {
    id: 'patient_reassessment',
    name: 'Автоматическая переоценка пациента системой «Webiomed»'
  }
]
